import createDOMPurify from "dompurify";

export function sanitizeHealthNoteContent(content: string): string {
  const purifier = createDOMPurify(window);
  purifier.addHook("afterSanitizeAttributes", node => {
    if (node.nodeName === "A" && node.hasAttribute("href")) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  return purifier.sanitize(content, {
    ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "ul", "ol", "li", "h1", "h2", "h3", "h4", "blockquote", "span", "div", "a"],
    ALLOWED_ATTR: ["href", "title", "lang", "dir"],
    ALLOWED_URI_REGEXP: /^https?:\/\//i,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    RETURN_TRUSTED_TYPE: false,
  });
}
